/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.UserChirpService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const searchUsersOnPortalRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.UserChirpService',
  rpcName: 'searchUsersOnPortal',
  auth: 'app',
  fingerprint: 'bid7Hi67idiOLlOK913PRJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};